<style lang="less" scoped>
.imgList {
    width: 75px;
    height: 75px;
    border: solid #888 1px;
    float: left;
    margin-top: 10px;
    margin-right: 10px;
    cursor:move;
    transition: 0.3s;
    background-size: cover;
    background-position: center;
    position: relative;
    &:hover {
        box-shadow: 0 0 5px #333;
    }
}
.delImg {
    position: absolute;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background: #E50000;
    cursor: pointer;
    right: -7px;
    top: -7px;
    display: flex;
    transition: 0.3s;
    &:hover {
        transform: rotate(180deg);
    }
    >div {
        width: 60%;
        height: 3px;
        margin: auto;
        background: #FFF;
    }
    
}
.mt10 {
    margin-top: 10px;
}
.static {
    position: static !important;
    margin-left: 10px;
}
.msgIcon {
    position: relative;
    >span {
        position: absolute;
        left: 55%;
        top: -10px;
        background: #FF9900;
        color: #FFF;
        width: 50px;
        font-size: 12px;
        border-radius: 10px;;
    }
}
</style>

<template>
    <div>
        <h2 class="pageTitle">產品列表</h2>

        <!-- 搜索Box -->
        <div class="sb searchBoxWrap">
            <div class="al">
                <Input type="text" v-model="keyword" clearable @on-clear="search" @on-keydown.enter="search" /> 
                <Button type="primary" class="searchBtn" @click="search">搜索</Button>
            </div>
            <div>
                <Button type="info" @click="showAdd=true">+ 創建新產品</Button>
            </div>
        </div>

        <div class="tableWrap">
            <Table :columns="columns" :data="list" border :loading="tableLoad">
                <template slot="action" slot-scope="{row}">
                    <div class="ju">
                        <Button type="warning" size='small' style="margin-right: 10px;" @click="edit(row)">編輯</Button>
                        <Button type="error" size='small' @click="del(row)">刪除</Button>
                    </div>
                </template>

                <template slot="category_id" slot-scope="{row}">
                    <div>{{categories.find(item => item.uuid==row.category_id) ? categories.find(item => item.uuid==row.category_id).name : ""}}</div>
                </template>

                <template slot="store" slot-scope="{row}">
                    <div v-if="row.store>row.store_level" style="color: green;">{{row.store}}</div>
                    <div class="msgIcon" v-else-if="row.store===0" style="color: #E50000;">{{row.store}}  <span>缺貨</span></div>
                    <div class="msgIcon" v-else style="color: #FF9900;">{{row.store}}  <span>缺貨</span></div>
                </template>
            </Table>
        </div>

        <div class="PageWrap">
            <Page :current="page" :page-size="offset" :total="total" @on-change="changePage" ></Page>
        </div>

        <!-- 創建 -->
        <Modal v-model="showAdd">
            <div slot="header" class="ModalHeader">
                <div>創建新產品</div>
            </div>

            <div>
                <Form :model="addForm" :rules="rules" :label-width="130" ref="addForm">
                    <FormItem prop="category_id" label="產品分類">
                        <Select v-model="addForm.category_id" style="width:250px" @on-keydown.enter="okAdd" >
                            <Option v-for="(item) in categories" :key="item.uuid" :value="item.uuid">{{item.name}}</Option>
                        </Select>
                    </FormItem>

                    <FormItem prop="name" label="產品名稱">
                        <Input v-model="addForm.name" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem prop="place" label="產地名稱">
                        <Input v-model="addForm.place" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem prop="price" label="價格">
                        <Input v-model="addForm.price" type="number" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem prop="sku" label="產品編號">
                        <Input v-model="addForm.sku" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem prop="store" label="庫存">
                        <Input type="number" v-model="addForm.store" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem prop="store_level" label="庫存等級">
                        <Input type="number" v-model="addForm.store_level" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem prop="intro" label="產品介紹">
                        <Input v-model="addForm.intro" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem prop="format" label="產品規格">
                        <div v-for="(item,i) in addForm.formatArr" :key="i" class="al relative">
                            <Input @on-change="enterFormart('addForm')" v-model="item.format" style="width:250px" @on-keydown.enter="okAdd" />
                            <div class="delImg static" @click="delFormat('addForm', i)"><div></div></div>
                        </div>
                    </FormItem>

                    <FormItem>
                        <div>
                            <Button type="info" @click="addFormat('addForm')" size="small" class="blueBtn">新增規格</Button>
                        </div>
                    </FormItem>

                    <FormItem prop="remark" label="備註">
                        <Input type="textarea" v-model="addForm.remark" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem label="" prop="imgStr">
                        <Upload :action="baseURL + 'admin/upload'" multiple :on-success="uploadSuccess1" name="file" :headers="headers" :show-upload-list="false">
                            <Button type="primary" size="small"  class="blueBtn">新增圖片</Button>
                        </Upload>
                        

                        <div class="clearBoth" style="width: 80%;">
                            <div class="imgList" 
                                :style="{'background-image': `url(${item})`}"
                                draggable="true" @dragover="dragover" @dragstart="dragstart(i)" @drop="drop(i, 'addForm')"
                                v-for="(item,i) in addForm.img" :key="item">
                                <div class="delImg" @click="delImg(i,'addForm')"><div></div></div>
                            </div>
                        </div>
                    </FormItem>
                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showAdd=false"> 取消 </Button>
                <Button type="info" size="small" @click="okAdd" :loading="load">+ 創建</Button>
            </div>
        </Modal>

        <!-- 編輯 -->
        <Modal v-model="showEdit">
            <div slot="header" class="ModalHeader">
                <div>編輯產品</div>
            </div>

            <div>
                <Form :model="editForm" :rules="rules" :label-width="130" ref="editForm">
                    <FormItem prop="category_id" label="產品分類">
                        <Select v-model="editForm.category_id" style="width:250px" @on-keydown.enter="okEdit" >
                            <Option v-for="(item) in categories" :key="item.uuid" :value="item.uuid">{{item.name}}</Option>
                        </Select>
                    </FormItem>

                    <FormItem prop="name" label="產品名稱">
                        <Input v-model="editForm.name" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>

                    <FormItem prop="place" label="產地名稱">
                        <Input v-model="editForm.place" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>

                    <FormItem prop="price" label="價格">
                        <Input v-model="editForm.price" type="number" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>

                    <FormItem prop="sku" label="產品編號">
                        <Input v-model="editForm.sku" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>

                    <FormItem prop="store" label="庫存">
                        <Input type="number" v-model="editForm.store" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>

                    <FormItem prop="store_level" label="庫存等級">
                        <Input type="number" v-model="editForm.store_level" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>

                    <FormItem prop="intro" label="產品介紹">
                        <Input v-model="editForm.intro" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>

                    <FormItem prop="format" label="產品規格">
                        <div v-for="(item,i) in editForm.formatArr" :key="i" class="al relative">
                            <Input @on-change="enterFormart('editForm')" v-model="item.format" style="width:250px" @on-keydown.enter="okEdit" />
                            <div class="delImg static" @click="delFormat('editForm', i)"><div></div></div>
                        </div>
                    </FormItem>

                    <FormItem>
                        <div>
                            <Button type="info" @click="addFormat('editForm')" size="small" class="blueBtn">新增規格</Button>
                        </div>
                    </FormItem>

                    <FormItem prop="remark" label="備註">
                        <Input type="textarea" v-model="editForm.remark" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>

                    <FormItem label="" prop="imgStr">
                        <Upload :action="baseURL + 'admin/upload'" multiple :on-success="uploadSuccess2" name="file" :headers="headers" :show-upload-list="false">
                            <Button type="primary" size="small"  class="blueBtn">新增圖片</Button>
                        </Upload>
                        

                        <div class="clearBoth" style="width: 80%;">
                            <div class="imgList" 
                                :style="{'background-image': `url(${item})`}"
                                draggable="true" @dragover="dragover" @dragstart="dragstart(i)" @drop="drop(i, 'editForm')"
                                v-for="(item,i) in editForm.img" :key="item">
                                <div class="delImg" @click="delImg(i,'editForm')"><div></div></div>
                            </div>
                        </div>
                    </FormItem> 
                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showEdit=false"> 取消 </Button>
                <Button type="info" size="small" @click="okEdit" :loading="load">編輯</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data () {
        return {
            columns: [
                { title: "編號", key: "id", sortable: true, align:"center", width: 100 },
                { title: "產品分類", key: "category_id", sortable: true, align:"center", slot: "category_id" },
                { title: "產品名稱", key: "name", sortable: true, align:"center" },
                { title: "產地名稱", key: "place", sortable: true, align:"center" },
                { title: "庫存", key: "store", sortable: true, align:"center", slot: "store" },
                { title: "庫存等級", key: "store_level", sortable: true, align:"center" },
                { title: "價格", key: "price", sortable: true, align:"center" },
                // { title: "規格", key: "format", sortable: true, align:"center" },
                { title: "創建時間", key: "createAt", sortable: true, align:"center" },
                { title: "操作", slot: "action", align:"center",  width: "160" },
            ],
            list: [
                // { id: "1" , name: "abc"},
                // { id: "2" , name: "哈哈"},
                // { id: "3" , name: "嘻嘻"},
            ],
            headers: {
                Authorization: localStorage.getItem("JWT")
            },
            keyword: "",
            page: 1,
            total: 0,
            showAdd: false,
            showEdit: false,
            addForm: {
                name: "",
                category_id:"",
                store:"",
                store_level:"",
                price:"",
                intro:"",
                commodity_detail:{},   //img_list: []
                create_time:"",
                sku:"",
                place: "",
                img: [],
                formatArr: [],
                remark: "",
                format:'',
                imgStr: ''
            },
            editForm: {
                name: "",
                category_id:"",
                store:"",
                store_level:"",
                price:"",
                intro:"",
                
                commodity_detail:{},   //img_list: []
                create_time:"",
                sku:"",
                place:"",
                img: [],
                formatArr: [],
                remark: "",
                format:"enter",
                imgStr: 'enter'
            },
            rules: {
                name: [ { required: "true", message: "請輸入產品名稱", trigger: "blur" } ],
                category_id: [ { required: "true", message: "請選擇產品分類" } ],
                store_level: [ { required: "true", message: "請輸入庫存等級", trigger: "blur" } ],
                store: [ { required: "true", message: "請輸入庫存", trigger: "blur" } ],
                price: [ { required: "true", message: "請輸入產品價格", trigger: "blur" } ],
                intro: [ { required: "true", message: "請輸入產品介紹", trigger: "blur" } ],
                format: [ { required: "true", message: "請至少輸入一個產品規格", trigger: "blur" } ],
                sku: [ { required: "true", message: "請輸入產品編號", trigger: "blur" } ],
                place: [ { required: "true", message: "請輸入產地", trigger: "blur" } ],
                // imgStr: [ { required: "true", message: "請至少上傳一張圖片" } ],
                // remark: [ { required: "true", message: "請輸入備註" } ],
            },
            load: false,
            startImg: -1,
            baseURL:"",
            tableLoad: false,
            categories:[]
        }
    },
    watch: {
        showAdd () {
            this.load = false
            if (this.addForm.formatArr.length===0) {
                this.addFormat('addForm')
            }
        },
        showEdit () { this.load = false },
    },
    computed: {
        role () { return this.$store.state.role },
        offset () { return this.$store.state.offset },
    },
    created () {
        if (this.role == 2) {
            this.columns.pop()
        }
        this.baseURL = window.baseURL
        this.showTable()
        this.getCate()
    },
    methods:{
        //刪除一個規格
        delFormat (key, i) {
            this[key].formatArr.splice(i,1)
            if (this[key].formatArr.length===0) {
                this.addFormat(key)
            }
        },
        //輸入規格
        enterFormart (key) {
            let boo = this[key].formatArr.find(item => item.format)
            this[key].format = boo ? "enter" : ""
        },
        //新增規格
        addFormat (key) {
            this[key].formatArr.push({
                formart: ""
            })
        },
        search () {
            this.page = 1
            this.showTable()
        },
        syncImg (key) {
            this[key].imgStr = this[key].img.length ? 'enter' : ""
        },
        //新增Mdoal 上傳圖片
        uploadSuccess1 (e) {
            // console.log(e)
            if (e.img_url) {
                this['addForm'].img.push(e.img_url)
            }
            this.syncImg('addForm')
        },
        // 編輯Modal 上傳圖片
        uploadSuccess2 (e) {
            // console.log(e)
            if (e.img_url) {
                this['editForm'].img.push(e.img_url)
            }
            this.syncImg('editForm')
        },
        //獲取商品
        showTable () {
            this.tableLoad = true
            this.$axios({
                url: "admin/commodity",
                params: {
                    page: this.page,
                    offset: this.offset,
                    search: this.keyword
                }
            }).then(res => {
                console.log(res)
                this.tableLoad = false
                if (res.data.data) {
                    this.list = res.data.data
                    this.total = res.data.count
                    if (res.data.data.length == 0 && this.page > 1) {
                        this.page--
                        this.showTable()
                    }
                } else {
                    this.list = []
                    this.total = 0
                }
            }).catch(e => {
                console.log(e)
                this.tableLoad = false
                this.$Message.error("網絡錯誤, 請稍後再試")
            })
        },
        changePage (e) {
            this.page = e
            this.showTable()
        },
        //獲取產品分類
        getCate () {
            this.$axios({
                url: "admin/category?page=1&offset=99999"
            }).then(res => {
                this.categories = res.data.data
            })
        },
        okAdd () {
            let that =this
            this.$refs.addForm.validate(flag => {
                if (flag) {
                    that.load = true
                    that.addForm.formatArr = that.addForm.formatArr.filter(item => item.format)
                    that.$axios({
                        url: "admin/commodity",
                        method:"POST",
                        data: {
                            name: that.addForm.name,
                            sku: that.addForm.sku,
                            category_id: that.addForm.category_id,
                            store: that.addForm.store * 1,
                            store_level: that.addForm.store_level * 1,
                            price: that.addForm.price * 1,
                            intro: that.addForm.intro,
                            format: that.addForm.formatArr.map(item => item.format),
                            place: that.addForm.place,
                            commodity_detail: that.addForm.commodity_detail,
                            img: that.addForm.img,
                            remark: that.addForm.remark,
                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.code == 200) {
                            that.$Message.success("創建成功")
                            that.showTable()
                            that.showAdd = false
                            that.$refs.addForm.resetFields()
                            that.addForm.formatArr= []
                            that.addFormat('addForm')
                            that.addForm.img = []
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        okEdit () { 
            let that =this
            this.$refs.editForm.validate(flag => {
                if (flag) {
                    that.load = true
                    that.editForm.formatArr = that.editForm.formatArr.filter(item => item.format)
                    that.$axios({
                        url: "admin/commodity",
                        method:"PUT",
                        data: {
                            uuid: that.editForm.uuid,
                            name: that.editForm.name,
                            sku: that.editForm.sku,
                            category_id: that.editForm.category_id,
                            store: that.editForm.store * 1,
                            store_level: that.editForm.store_level * 1,
                            price: that.editForm.price * 1,
                            intro: that.editForm.intro,
                            format: that.editForm.formatArr.map(item => item.format),
                            place: that.editForm.place,
                            commodity_detail: that.editForm.commodity_detail,
                            img: that.editForm.img,
                            remark: that.editForm.remark,

                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.code == 200) {
                            that.$Message.success("編輯成功")
                            that.showTable()
                            that.showEdit = false
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        edit (item) {
            this.showEdit = true
            let format = []
            item.format.forEach(item => {
                format.push({
                    format: item
                })
            })
            this.editForm.uuid = item.uuid
            this.editForm.sku = item.sku
            this.editForm.place = item.place
            this.editForm.name = item.name
            this.editForm.category_id = item.category_id
            this.editForm.store = item.store + ""
            this.editForm.store_level = item.store_level + ""
            this.editForm.price = item.price + ""
            this.editForm.intro = item.intro
            this.editForm.formatArr = format
            this.editForm.commodity_detail = item.commodity_detail
            this.editForm.img = item.img
            this.editForm.remark = item.remark

        },
        del (item) {
            let that = this
            that.$Modal.confirm({
                title: '提示',
                content : "確定刪除這條信息?",
                onOk () {
                    that.$axios({
                        url: "admin/commodity",
                        method:"DELETE",
                        data: {
                            uuid: item.uuid
                        }
                    }).then(res => {
                        that.$Message.success('已刪除')
                        that.showTable()
                    })
                }
            })
        },

        drop (i,key) {
            if (this.startImg != -1) {
                let one = this[key].img[this.startImg]
                let two = this[key].img[i]
                this[key].img.splice(this.startImg,1,two)
                this[key].img.splice(i,1,one)
            }
        },
        dragstart (i) { this.startImg = i },
        dragover (e) { e.preventDefault() },
        delImg (i,key) {
            this[key].img.splice(i,1)
        }

    }
}
</script>

